<select [ngModel]="selectedLanguage?.id" (ngModelChange)="onSelectLanguage($event)" id="type" name="type" class="form-control language-picker">
  <option [value]="null">All languages</option>

  <option [value]="lang.id" *ngFor="let lang of support.languages">
    {{ lang.name }}
  </option>
</select>
